import errorMessage from "../const/Tost";
import $api, {API_URL} from "./instance";

export const AuthService = {
    async login(data){
        try{
            return await $api.post(`${API_URL}/login`, data);
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    },

    async register(data){
        try{
            return await $api.post(`${API_URL}/register`, data);
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    },

    async checkAuth(){
        try{
            return await $api.get(`${API_URL}/refresh`, {withCredentials: true});
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    },

    async logout(){
        try{
            return await $api.post(`${API_URL}/logout`);
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    },
};
